import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { PaymentStatesComponent } from './PaymentStatesComponent';

class PaymentStatesContainer extends Component {
  constructor() {
    super();

    this.state = {
      isSent: false,
    };
  }

  setSent = () => this.setState({ isSent: true });

  render() {
    const { isSent } = this.state;
    const { schoolName, cost, schoolId } = this.props;

    return (
      <PaymentStatesComponent
        isSent={isSent}
        setSent={this.setSent}
        schoolName={schoolName}
        cost={cost}
        schoolId={schoolId}
      />
    );
  }
}

PaymentStatesContainer.propTypes = {
  schoolName: PropTypes.string.isRequired,
  cost: PropTypes.string.isRequired,
  schoolId: PropTypes.string.isRequired,
};

export { PaymentStatesContainer };
